import { render, staticRenderFns } from "./rcc-checkboxes-group.vue?vue&type=template&id=51ace202&scoped=true&"
import script from "./rcc-checkboxes-group.vue?vue&type=script&lang=js&"
export * from "./rcc-checkboxes-group.vue?vue&type=script&lang=js&"
import style0 from "./rcc-checkboxes-group.vue?vue&type=style&index=0&id=51ace202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ace202",
  null
  
)

export default component.exports